import React from 'react';
import { Link } from 'react-router-dom';

import { Layout, Card, Breadcrumb, Row, Icon, Tabs } from 'antd';
// Others
import { strings } from '../../localization';
import { ROUTE_NAMES } from '../../utils';

import SmartPiSwitches from './SmartPi';

const { TabPane } = Tabs;

const Tests = () => (
    <Layout key="testing-content">
        <Layout.Content style={{ padding: '10px' }}>
            <Card style={{ marginBottom: '30px' }}>
                <h2 data-testid="headline">{strings.tests.route}</h2>
                <Breadcrumb separator=">">
                    <Breadcrumb.Item>{strings.appName}</Breadcrumb.Item>
                    <Breadcrumb.Item>
                        <Link to={ROUTE_NAMES.TESTS}>
                            <Icon type="deployment-unit" />
                            &nbsp;
                            {strings.tests.route}
                        </Link>
                    </Breadcrumb.Item>
                </Breadcrumb>
            </Card>
            <Row>
                <Row>
                    <Tabs
                        defaultActiveKey="0"
                        size="large"
                        tabBarGutter={30}
                        tabBarStyle={{ marginBottom: 0 }}
                    >
                        <TabPane
                            key="0"
                            tab={
                                <span>
                                    <Icon type="bulb" />
                                    {strings.tests.smartPiTests}
                                </span>
                            }
                        >
                            <SmartPiSwitches />
                        </TabPane>
                    </Tabs>
                </Row>
            </Row>
        </Layout.Content>
    </Layout>
);

export default Tests;
